import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTextAlignCenter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.125 4.6875C2.77982 4.6875 2.5 4.96732 2.5 5.3125C2.5 5.65768 2.77982 5.9375 3.125 5.9375H16.875C17.2202 5.9375 17.5 5.65768 17.5 5.3125C17.5 4.96732 17.2202 4.6875 16.875 4.6875H3.125ZM5 7.8125C4.65482 7.8125 4.375 8.09232 4.375 8.4375C4.375 8.78268 4.65482 9.0625 5 9.0625H15C15.3452 9.0625 15.625 8.78268 15.625 8.4375C15.625 8.09232 15.3452 7.8125 15 7.8125H5ZM2.5 11.5625C2.5 11.2173 2.77982 10.9375 3.125 10.9375H16.875C17.2202 10.9375 17.5 11.2173 17.5 11.5625C17.5 11.9077 17.2202 12.1875 16.875 12.1875H3.125C2.77982 12.1875 2.5 11.9077 2.5 11.5625ZM5 14.0625C4.65482 14.0625 4.375 14.3423 4.375 14.6875C4.375 15.0327 4.65482 15.3125 5 15.3125H15C15.3452 15.3125 15.625 15.0327 15.625 14.6875C15.625 14.3423 15.3452 14.0625 15 14.0625H5Z",
		fill: "currentColor"
	})
});
export default SvgTextAlignCenter;
